import { removeTrapFocus, trapFocus } from '@theme/focus';

const dialog = document.getElementById('gift-card-confirmation');
const proceed = dialog.querySelector('.gift-handoff__continue');
let trigger;
let drawer;

document.addEventListener('click', (event) => {
  const link = event.target.closest?.('a[href]');
  if (!link || dialog.contains(link)) return;
  const url = new URL(link.href, location.href);
  if (!['www.toasttab.com', 'toasttab.com'].includes(url.hostname) || url.pathname !== '/kaizenandcoffee/giftcards') return;
  event.preventDefault();
  event.stopImmediatePropagation();
  trigger = link;
  drawer = link.closest('header-drawer');
  removeTrapFocus();
  proceed.href = url.href;
  dialog.toggleAttribute('data-pointer-open', event.detail !== 0);
  dialog.showModal();
  dialog.querySelector('[data-gift-close]').focus();
}, true);

document.addEventListener('keydown', () => dialog.removeAttribute('data-pointer-open'), true);

dialog.querySelectorAll('[data-gift-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
proceed.addEventListener('click', () => dialog.close());
dialog.addEventListener('click', (event) => {
  if (event.target !== dialog) return;
  const box = dialog.getBoundingClientRect();
  if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
});
dialog.addEventListener('close', () => {
  if (drawer?.isConnected && drawer.querySelector('details[open]')) trapFocus(drawer);
  trigger?.focus();
});
